import {
  // -- GET (list)
  GET_ALPHA_FACTORS_SUCCESS,
  GET_ALPHA_FACTORS_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

let cacheItems = null

export const alphaFactors = (state = {}, action) => {
  switch (action.type) {
    // -- GET ALPHA FACTORS (list)
    case GET_ALPHA_FACTORS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] alphaFactors.GET_ALPHA_FACTORS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_ALPHA_FACTORS_SUCCESS: {
      cacheItems = action.data || []

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] alphaFactors.GET_FLOW_CONDITIONS_SUCCESS()', { state, action })

      return {
        ...state,
        items: cacheItems
      }
    }

    default:
      return state
  }
}
